<p-toast></p-toast>

<div class="management-shell">
  @if (error()) {
    <div class="error-state">{{ error() }}</div>
  } @else {
    <section class="page-hero">
      <div class="hero-main">
        <div class="entity-logo">
          @if (company()?.logo) {
            <img [src]="company()?.logo" [alt]="company()?.name || 'Company'" />
          } @else {
            {{ (company()?.name || 'C').charAt(0) }}
          }
        </div>
        <div>
          <span class="eyebrow">Company</span>
          <h1 class="hero-title">Edit Company</h1>
          <div class="hero-meta">
            <span class="chip">Identity fields locked</span>
          </div>
        </div>
      </div>
      <div class="hero-actions">
        <button pButton type="button" label="Back" icon="pi pi-arrow-left" severity="secondary" [routerLink]="['/company']"></button>
      </div>
    </section>

    <section class="panel mt-3">
      <form [formGroup]="form" class="form-grid" (ngSubmit)="save()">
        <div class="field full">
          <label>Company Logo</label>
          <div class="hero-main">
            <div class="entity-logo">
              @if (form.get('logo')?.value) {
                <img [src]="form.get('logo')?.value" [alt]="company()?.name || 'Company logo'" />
              } @else {
                {{ (company()?.name || 'C').charAt(0) }}
              }
            </div>
            <div>
              <p-fileUpload
                mode="basic"
                [chooseLabel]="isUploadingLogo() ? 'Uploading...' : (form.get('logo')?.value ? 'Replace Logo' : 'Upload Logo')"
                [chooseIcon]="isUploadingLogo() ? 'pi pi-spin pi-spinner' : 'pi pi-upload'"
                accept="image/*"
                maxFileSize="5000000"
                [auto]="true"
                [disabled]="isUploadingLogo()"
                (onSelect)="onLogoUpload($event)"
                [styleClass]="form.get('logo')?.value ? 'p-button-outlined' : ''">
              </p-fileUpload>
              <div class="locked-hint mt-2">Upload an image. The Firebase download URL is saved to the company logo field.</div>
            </div>
          </div>
        </div>

        <div class="field full">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <app-location-search id="companyLocationSearch" formControlName="searchLocation" (placeSelected)="placeSelect($event)"></app-location-search>
              <label for="companyLocationSearch">Google Maps Search</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Selecting a place updates place ID, address, phone, website, logo, country, and available business fields.</span>
        </div>

        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="companyName" formControlName="name" placeholder=" " />
              <label for="companyName">Company Name</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">Company name cannot be edited here.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="crNumber" type="number" formControlName="crNumber" placeholder=" " />
              <label for="crNumber">CR Number</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">CR number cannot be edited here.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-receipt"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="taxRegNumber" formControlName="taxRegNumber" placeholder=" " />
              <label for="taxRegNumber">VAT Number</label>
            </p-iftaLabel>
          </p-inputGroup>
          <span class="locked-hint">VAT number cannot be edited here.</span>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-phone"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="phoneNumber" formControlName="phoneNumber" placeholder=" " />
              <label for="phoneNumber">Phone</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-envelope"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="emailAddress" formControlName="emailAddress" placeholder=" " />
              <label for="emailAddress">Email</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="websiteURL" formControlName="websiteURL" placeholder=" " />
              <label for="websiteURL">Website</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-inbox"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <input pInputText id="poBox" type="number" formControlName="poBox" placeholder=" " />
              <label for="poBox">PO Box</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="field">
          <p-inputGroup>
            <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
            <p-iftaLabel>
              <p-select inputId="countryId" formControlName="countryId" [options]="countries()" optionLabel="name" optionValue="id" [filter]="true" filterBy="name,countryCode" appendTo="body" styleClass="w-full"></p-select>
              <label for="countryId">Country</label>
            </p-iftaLabel>
          </p-inputGroup>
        </div>
        <div class="form-actions full">
          <button pButton type="button" label="Cancel" severity="secondary" [text]="true" [routerLink]="['/company']"></button>
          <button pButton type="submit" label="Save Company" icon="pi pi-save" [loading]="isSaving()"></button>
        </div>
      </form>
    </section>
  }
</div>
